import { ACCOUNTS_PATH } from '@/components/Entities/paths';
type AccountPageTarget = {
  AccountID: string;
  /** Plain string rather than the vopay currency union: the shared lists hand the row's currency back as one. */
  Currency?: string;
};

/**
 * Where an account's row leads: the account page, for a top-level account and a sub-account alike —
 * one page serves both, and reads everything about the account from its own request. The link carries
 * only the currency of the row that was clicked, and must carry nothing else: the page embeds shared
 * lists that treat every query parameter as one of their own filters, so a stray `accountStatus=Active`
 * would silently filter a tab.
 */
export default function accountPageLocation({ AccountID, Currency }: AccountPageTarget) {
  return {
    pathname: `${ACCOUNTS_PATH}/${AccountID}`,
    // Without a currency the page shows the account's first balance.
    search: Currency ? new URLSearchParams({ currency: Currency }).toString() : '',
  };
}
